import React, { Component } from 'react';
import Generator from '../components/generator/Generator.jsx';
import { connect } from 'react-redux';
import WebFont from 'webfontloader';
import { setFonts } from '../store/actions/fonts';

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFonts: (fontObj) => {
      dispatch(setFonts(fontObj));
    },
  }
}

class FontsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingInfo: true,
      loadingFonts: false,
    }
    this.fontsLoaded = this.fontsLoaded.bind(this);
    this.loadFonts = this.loadFonts.bind(this);
  }

  fontsLoaded() {
    this.setState({
      loadingFonts: false
    });
  }

  loadFonts(fonts) {
    const {
      setFonts,
    } = this.props;

    const {primary, secondary } = fonts;
    
    const newFonts = {
      primary: {
        name: primary,
      },
      secondary: {
        name: secondary
      }
    }

    setFonts(newFonts);
    this.fontsLoaded();

    WebFont.load({
      google: {
        families: [primary, secondary]
      },
      active: this.fontsLoaded
    });
  }


  componentDidMount() {
    const {
      params
    } = this.props;

    console.log('params', params)
    this.loadFonts(params);
    this.setState({
      loadingInfo: false
    })
  }

  componentWillReceiveProps(newProps) {
    const {
      params
    } = newProps;

    this.setState({
      loadingFonts: true,
      loadingInfo: true,
    });

    this.loadFonts(params);
    this.setState({
      loadingInfo: false
    })
  }

  render () {
    const {
      loadingInfo,
      loadingFonts,
    } = this.state;

    return (
      <Generator loading={loadingInfo || loadingFonts} />
    )
  }
}

export default FontsContainer = connect(undefined, mapDispatchToProps)(FontsContainer);



// WEBPACK FOOTER //
// ./src/containers/FontsContainer.jsx